// ported from jQuery's $.type
const classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
]) {
    classToType[`[object ${name}]`] = name.toLowerCase();
}
export default function (obj) {
    return classToType[Object.prototype.toString.call(obj)] || 'object';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/utils/type.js
// module id = 201
// module chunks = 6